export const WITHDRAWALS_SEARCH_RESULT_TEST_ID = 'withdrawals-search-result';
